// @flow
export const EVENT_CREATE_ERROR: "EVENT_CREATE_ERROR" = "EVENT_CREATE_ERROR";
export const EVENT_CREATE_LOADING: "EVENT_CREATE_LOADING" =
    "EVENT_CREATE_LOADING";
export const EVENT_CREATE_SUCCESS: "EVENT_CREATE_SUCCESS" =
    "EVENT_CREATE_SUCCESS";
export const EVENT_CREATE_REQUESTED: "EVENT_CREATE_REQUESTED" =
    "EVENT_CREATE_REQUESTED";

export const GET_REGIONS: "GET_REGIONS" = "GET_REGIONS";
export const GET_DEPARTMENTS: "GET_DEPARTMENTS" = "GET_DEPARTMENTS";
export const GET_NATURE_TYPES: "GET_NATURE_TYPES" = "GET_NATURE_TYPES";
export const GET_NETWORK_TYPES: "GET_NETWORK_TYPES" = "GET_NETWORK_TYPES";
export const GET_STRUCTURE_TYPES: "GET_STRUCTURE_TYPES" = "GET_STRUCTURE_TYPES";

export const EVENT_DATA_LOADING: "EVENT_DATA_LOADING" = "EVENT_DATA_LOADING";
export const EVENT_DATA_SUCCESS: "EVENT_DATA_SUCCESS" = "EVENT_DATA_SUCCESS";
export const EVENT_DATA_ERROR: "EVENT_DATA_ERROR" = "EVENT_DATA_ERROR";
